// Port of api/fuel/app/classes/filter/search/games/rules/query/rating_disparity.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'rating_disparity',
	field: function() { return '!uc_disparity' },
	pre: function(rule, config, filter, data, query) {
		query.select('r.rating_value - g.game_rating_avg', 'uc_disparity')
	}
})
